import axios, { AxiosError } from 'axios';
import { getConfig } from '@creditornot/converse-shared';
import { apiUrlByEnv, maxRetryCount } from './constants';
import { reconnectAfterMs, waitAsync } from './utils';
/**
 * @deprecated Use Platform API auth flow instead
 */
export const tempExchangeWoltAccessToken = (woltAccessToken) => 
// eslint-disable-next-line prefer-arrow-functions/prefer-arrow-functions
(async function exchangeWoltAccessToken(tries = 0) {
    const config = getConfig();
    const axiosInstance = axios.create();
    const grant = config.sdkType === 'workspace'
        ? {
            grantType: 'wolt_access_token',
            audience: 'converse_workspace',
            workspaceId: config.workspaceId,
            accessToken: woltAccessToken,
        }
        : {
            grantType: 'wolt_access_token',
            audience: 'converse_widget',
            workspaceId: config.workspaceId,
            accessToken: woltAccessToken,
            appId: config.appId,
        };
    try {
        const response = await axiosInstance.post(`${apiUrlByEnv[config.env]}/auth-api/v1/token`, grant);
        return response.data;
    }
    catch (error) {
        if (error instanceof AxiosError) {
            // do not retry if credentials are invalid
            if (error.response?.status === 401) {
                throw error;
            }
        }
        const nextTry = tries + 1;
        if (nextTry > maxRetryCount) {
            // stop retrying after reaching attempts limit
            throw error;
        }
        await waitAsync(reconnectAfterMs(nextTry));
        return exchangeWoltAccessToken(nextTry);
    }
})();
//# sourceMappingURL=wolt.js.map